import {Box, Button, Stack, Typography} from "@mui/material";
import {motion, useScroll, useTransform} from "framer-motion";
import {useRef} from "react";
import {STYLE} from "./STYLES";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import {useNavigate} from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();
  const heroRef = useRef(null);
  const {scrollY} = useScroll();

  // Parallax effect values
  const leftImageY = useTransform(scrollY, [0, 500], [0, -100]);
  const rightImageY = useTransform(scrollY, [0, 500], [0, -75]);

  const onHeroPrimaryButtonClick = () => {
    navigate("/cat");
  };

  const onHeroSecondaryButtonClick = () => {
    navigate("/cat");
  };

  return (
    <Box ref={heroRef} sx={STYLE.heroContainer}>
      {/* Main content */}
      <Stack sx={STYLE.heroContent}>
        <Typography sx={STYLE.heroTitle}>THE AI EXAM PRACTICE</Typography>

        <Typography sx={STYLE.heroSubtitle}>
          Preparation made{" "}
          <i>
            <b>faster</b>
          </i>{" "}
          and{" "}
          <i>
            <b>smarter</b>
          </i>
          . PrepGenie is the best way to get exam-ready.
        </Typography>

        <Box height={32} />

        <Stack direction="row" spacing={2} justifyContent="center">
          <Box
            sx={{p: 0.5, borderRadius: "12px", border: "1px solid #CFCFCFA0"}}>
            <Button
              variant="contained"
              sx={STYLE.heroButtonPrimary}
              onClick={onHeroPrimaryButtonClick}>
              Start for free
            </Button>
          </Box>

          <Box
            sx={{p: 0.5, borderRadius: "12px", border: "1px solid #CFCFCFA0"}}>
            <Button
              variant="outlined"
              sx={STYLE.heroButtonSecondary}
              endIcon={<EastOutlinedIcon fontSize="small" />}
              onClick={onHeroSecondaryButtonClick}>
              CAT Exam
            </Button>
          </Box>
        </Stack>
      </Stack>

      <Box height={64} />

      {/* Box for background image */}
      <Box sx={{width: "100%", flex: 1, mx: "auto", position: "relative"}}>
        <Box id="hero-section-image" sx={STYLE.heroMainImage} />
        <Box id="hero-section-gradient" sx={STYLE.heroGradient} />
        {/* Left parallax image container */}
        <motion.div
          style={{
            position: "absolute",
            left: "2.5%",
            bottom: "20%",
            y: leftImageY,
            width: "23.5vw",
            height: "14vw",
            zIndex: 0,
          }}>
          <Box sx={STYLE.heroLeftImage} />
        </motion.div>
        {/* Right parallax image container */}
        <motion.div
          style={{
            position: "absolute",
            right: "2.5%",
            top: "20%",
            y: rightImageY,
            width: "15vw",
            height: "28.2vw",
            zIndex: 0,
          }}>
          <Box sx={STYLE.heroRightImage} />
        </motion.div>
      </Box>
    </Box>
  );
}
